import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';


@Injectable({
  providedIn: 'root'
})
export class SharedApiService {
  private readonly apiUrl = environment.apiUrl;
  private readonly apiUrl2 = environment.apiUrl2;

  private http = inject(HttpClient)

  private get defaultLang(): string {
    return localStorage.getItem('lang') || 'ar';
  }

  // private buildParams(paramsObj: Record<string, any> = {}): HttpParams {
  //   let params = new HttpParams().set('language', this.defaultLang);

  //   Object.keys(paramsObj).forEach(key => {
  //     const value = paramsObj[key];
  //     if (value !== null && value !== undefined && value !== '') {
  //       params = params.set(key, value.toString());
  //     }
  //   });

  //   return params;
  // }

  private buildParams(paramsObj: Record<string, any> = {}): HttpParams {
  let params = new HttpParams().set('language', this.defaultLang);

  Object.keys(paramsObj).forEach(key => {
    const value = paramsObj[key];

    if (value !== null && value !== undefined && value !== '') {
      if (Array.isArray(value)) {
        // append لكل عنصر بدل set عشان يبعَت كـ multi-value
        value.forEach(v => {
          params = params.append(key, v.toString());
        });
      } else {
        params = params.set(key, value.toString());
      }
    }
  });

  return params;
}


  getAll(endpoint: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${endpoint}`, {
      params: this.buildParams()
    });
  }

  getAll2(endpoint: string): Observable<any> {
    const token = localStorage.getItem('token'); // خدي التوكن من localStorage
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}` // ضيفيها في الـ Header
    });
    return this.http.get<any>(`${this.apiUrl2}${endpoint}`, { headers });
  }

  getById(endpoint: string, id: number | string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${endpoint}`, {
      params: this.buildParams({ Id: id })
    });
  }

  getById2(endpoint: string, id: number | string): Observable<any> {
    const token = localStorage.getItem('token'); // خدي التوكن من localStorage
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}` // ضيفيها في الـ Header
    });
    return this.http.get<any>(`${this.apiUrl2}${endpoint}`, {
      params: this.buildParams({ Id: id }),
      headers: headers
    });
  }

  getAllWithPagination(
    endpoint: string,
    pageNumber: number = 1,
    pageSize: number = 10
  ): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${endpoint}`, {
      params: this.buildParams({
        PageNumber: pageNumber,
        PageSize: pageSize
      })
    });
  }

  getPaginatedFilteredSearch<T>(
    endpoint: string,
    paginator: { pageNumber: number; pageSize: number },
    filter?: Record<string, any>
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}${endpoint}`, {
      params: this.buildParams({
        PageNumber: paginator.pageNumber,
        PageSize: paginator.pageSize,
        ...(filter || {})
      })
    });
  }


  getWithFilter<T>(
    endpoint: string,
    filter?: Record<string, any>
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}${endpoint}`, {
      params: this.buildParams({
        ...(filter || {})
      })
    });
  }

  // getWithFilter<T>(endpoint: string, filter?: Record<string, any>): Observable<T> {
  //   let params = new HttpParams();

  //   Object.keys(filter || {}).forEach(key => {
  //     const value = filter![key];
  //     if (Array.isArray(value)) {
  //       value.forEach(v => {
  //         params = params.append(key, v); // append لكل عنصر
  //       });
  //     } else {
  //       params = params.set(key, value);
  //     }
  //   });

  //   return this.http.get<T>(`${this.apiUrl}${endpoint}`, { params });
  // }


  postData<T>(endpoint: string, body: any, paramsObj: Record<string, any> = {}): Observable<T> {
    const options = {
      params: this.buildParams(paramsObj)
    };

    return this.http.post<T>(`${this.apiUrl}${endpoint}`, body, options);
  }

  postData2<T>(endpoint: string, body: any, paramsObj: Record<string, any> = {}): Observable<T> {
    const options = {
      params: this.buildParams(paramsObj)
    };

    return this.http.post<T>(`${this.apiUrl2}${endpoint}`, body, options);
  }

  // UpdateData<T>(endpoint: string, body: any, paramsObj: Record<string, any> = {}): Observable<T> {
  //   const options = {
  //     params: this.buildParams(paramsObj)
  //   };

  //   return this.http.put<T>(`${this.apiUrl2}${endpoint}`, body, options);
  // }

  PostToJsonOrFormWithToken<T>(endpoint: string, body: any, paramsObj: Record<string, any> = {}): Observable<T> {
    const token = localStorage.getItem('token');
    const isFormData = body instanceof FormData;

    const headersConfig: any = {
      Authorization: `Bearer ${token}`
    };

    // لو البيانات مش FormData نحدد الـ Content-Type كـ JSON
    if (!isFormData) {
      headersConfig['Content-Type'] = 'application/json';
    }

    const options = {
      headers: new HttpHeaders(headersConfig),
      params: this.buildParams(paramsObj)
    };

    return this.http.post<T>(`${this.apiUrl2}${endpoint}`, body, options);
  }


  UpdateToJsonOrFormWithToken<T>(endpoint: string, body: any, paramsObj: Record<string, any> = {}): Observable<T> {
    const token = localStorage.getItem('token');
    const isFormData = body instanceof FormData;

    const headersConfig: any = {
      Authorization: `Bearer ${token}`
    };

    // لو البيانات مش FormData نحدد الـ Content-Type كـ JSON
    if (!isFormData) {
      headersConfig['Content-Type'] = 'application/json';
    }

    const options = {
      headers: new HttpHeaders(headersConfig),
      params: this.buildParams(paramsObj)
    };

    return this.http.put<T>(`${this.apiUrl2}${endpoint}`, body, options);
  }


  PatchToJsonOrFormWithToken<T>(endpoint: string, body: any, paramsObj: Record<string, any> = {}): Observable<T> {
    const token = localStorage.getItem('token');
    const isFormData = body instanceof FormData;

    const headersConfig: any = {
      Authorization: `Bearer ${token}`
    };

    // لو البيانات مش FormData نحدد الـ Content-Type كـ JSON
    if (!isFormData) {
      headersConfig['Content-Type'] = 'application/json';
    }

    const options = {
      headers: new HttpHeaders(headersConfig),
      params: this.buildParams(paramsObj)
    };

    return this.http.patch<T>(`${this.apiUrl2}${endpoint}`, body, options);
  }

  getImage(endpoint: string): Observable<Blob> {
    const token = localStorage.getItem('token');

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get(`${this.apiUrl2}${endpoint}`, {
      headers: headers,
      responseType: 'blob'
    });
  }

}
